import { StepList } from "@/components/Stepper/parts/StepperHeader/StepperHeader.component";
import { Calculator } from "@/models/calculator.model";
import { Category } from "@/models/categories.model";
import { AbacaDatas, GlobalSettings } from "@/models/global.model";
import {
  mapCalculatorDtoToCalculator,
  mapCategoriesDtoToCategories,
  mapSettingsDtoToSettings,
} from "@/services/mapper.service";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import store from "..";
import {
  UPDATE_CALCULATORS,
  UPDATE_CATEGORIES,
  UPDATE_CHAPO,
  UPDATE_CONDITIONS_ACCEPTED,
  UPDATE_GLOBAL_SETTINGS,
  UPDATE_ID,
  UPDATE_ILLUSTRATION,
  ACTION_INIT_DATAS,
  UPDATE_LOADED,
  UPDATE_NAME,
  UPDATE_SUBTITLE,
  UPDATE_TITLE,
  UPDATE_MENU_COLLAPSED,
  UPDATE_CURRENT_STEP,
  UPDATE_DATA_NAME,
  UPDATE_DATA_TYPE,
  RESET_SETTINGS,
  RESET_EQUIPMENTS,
  RESET_SITE_STORE,
  RESET_STORE,
  UPDATE_DATATYPE_VERSION,
} from "../operators";

/**
 * This module contains the base params from studio
 * It should not be updated directly by user inputs.
 */
@Module
export default class GlobalAppDataStore extends VuexModule {
  maxZoneNumber!: number;
  maxZoneVolume!: number;
  maxTotalVolume!: number;

  minimumRenewalRate!: number;
  maximumRenewalRate!: number;
  minimumDepression!: number;
  maximumDepression!: number;
  defaultDepression!: number;
  settings!: GlobalSettings;
  id = "";
  name = "";
  title = "";
  subTitle = "";
  loaded = false;
  conditions_accepted = false;
  categories: Category[] = [];
  chapo = "";
  illustration = "";
  calculators: Calculator[] = [];
  menuCollapsed = true;
  dataTypeVersion = "";
  currentStep = StepList.asbestos;

  // name of the app from studio, used for configuration
  dataName = "";

  // type of the app. Data returned from studio, used for configuration
  dataType = "";

  @Mutation
  public [UPDATE_GLOBAL_SETTINGS](globalData: GlobalSettings): void {
    this.settings = globalData;
  }

  @Mutation
  public [UPDATE_CURRENT_STEP](currentStep: number): void {
    this.currentStep = currentStep;
  }

  @Mutation
  public [UPDATE_CALCULATORS](value: Calculator[]): void {
    this.calculators = value;
  }

  @Mutation
  public [UPDATE_MENU_COLLAPSED](value: boolean): void {
    this.menuCollapsed = value;
  }

  @Mutation
  public [UPDATE_CATEGORIES](categoryList: Category[]): void {
    categoryList.sort((category1, category2) => category1.order - category2.order);
    this.categories = categoryList;
  }

  @Mutation
  public [UPDATE_TITLE](value: string): void {
    this.title = value;
  }

  @Mutation
  public [UPDATE_SUBTITLE](value: string): void {
    this.subTitle = value;
  }

  @Mutation
  public [UPDATE_CHAPO](value: string): void {
    this.chapo = value;
  }

  @Mutation
  public [UPDATE_NAME](value: string): void {
    this.name = value;
  }

  @Mutation
  public [UPDATE_ID](value: string): void {
    this.id = value;
  }

  @Mutation
  public [UPDATE_ILLUSTRATION](value: string): void {
    this.illustration = value;
  }

  @Mutation
  public [UPDATE_LOADED](value: boolean): void {
    this.loaded = value;
  }
  @Mutation
  public [UPDATE_CONDITIONS_ACCEPTED](value: boolean): void {
    this.conditions_accepted = value;
  }

  @Mutation
  public [UPDATE_DATA_NAME](value: string): void {
    this.dataName = value;
  }

  @Mutation
  public [UPDATE_DATA_TYPE](value: string): void {
    this.dataType = value;
  }

  @Mutation
  public [UPDATE_DATATYPE_VERSION](value: string): void {
    this.dataTypeVersion = value;
  }

  @Action
  public [ACTION_INIT_DATAS](abacaData: AbacaDatas): void {
    store.commit(UPDATE_CALCULATORS, mapCalculatorDtoToCalculator(abacaData.appData.calculateurs));
    store.commit(UPDATE_CATEGORIES, mapCategoriesDtoToCategories(abacaData.appData.categories));
    store.commit(UPDATE_TITLE, abacaData.appData.titre);
    store.commit(UPDATE_SUBTITLE, abacaData.appData.sousTitre);
    store.commit(UPDATE_CHAPO, abacaData.appData.chapo);
    store.commit(UPDATE_NAME, abacaData.appData.nom);
    store.commit(UPDATE_ID, abacaData.appData.identifiant);
    store.commit(UPDATE_ILLUSTRATION, abacaData.appData.illustration);
    store.commit(UPDATE_GLOBAL_SETTINGS, mapSettingsDtoToSettings(abacaData.appData.settings));
    store.commit(UPDATE_DATATYPE_VERSION, abacaData.dataTypeVersion);
    store.commit(UPDATE_DATA_NAME, abacaData.dataName);
    store.commit(UPDATE_DATA_TYPE, abacaData.dataType);
  }

  @Action [RESET_STORE](): void {
    store.commit(UPDATE_CURRENT_STEP, StepList.asbestos);
    store.dispatch(RESET_SETTINGS, this.settings);
    store.dispatch(RESET_EQUIPMENTS);
    store.dispatch(RESET_SITE_STORE);
  }
}
